import PlainButton from "components/buttons/PlainButton";
import { range } from "utils/range";
import styles from "css/buttons/BigToggleButton.module.css";
import NavLink from "components/text/NavLink";

type Props = {
  labels: Array<string>;
  onToggle: (val: number) => void;
  position: number;
};

export default function BigToggleButton({
  labels,
  onToggle,
  position,
}: Props): JSX.Element {
  const numToggles = labels.length;
  const toggleButtons = range(numToggles).map((val) => (
    <PlainButton
      key={val}
      className={styles.toggleButton}
      onClick={() => onToggle(val)}
    >
      <NavLink
        className={position === val ? styles.textWhite : styles.textGradient}
      >
        {labels[val]}
      </NavLink>
    </PlainButton>
  ));

  return (
    <div
      className={styles.toggle}
      style={{ gridTemplateColumns: `repeat(${numToggles}, minmax(0, 1fr))` }}
    >
      <div
        className={styles.toggleHighlight}
        style={{
          left: `calc((7px * (2 * ${position} + 1) + ((${
            100 / numToggles
          }% - 14px) * ${position}))`,
          width: `calc(${100 / numToggles}% - 14px)`,
        }}
      />
      {toggleButtons}
    </div>
  );
}
